import axios from "axios";
import { API_ORIGIN } from "../config/constants";

const authToken = localStorage.getItem("Authtoken");

export class OrderService {
  static orderCreate = async (values) => {
    try {
      let response = await axios({
        method: "post",
        baseURL: API_ORIGIN + "/orders/admin/create",
        data: values,
        headers: {
          "Content-Type": "application/json",
        },
      });
      let responseData = response.data.data;

      return responseData;
    } catch (err) {
      throw err;
    }
  };

  static orderCreateAdmin = async (
    name,
    address,
    phone,
    nic,
    role,
    email,
    password
  ) => {
    try {
      let response = await axios({
        method: "post",
        baseURL: API_ORIGIN + "/admin/create",
        data: {
          name: name,
          address: address,
          phone: phone,
          nic: nic,
          role: role,
          email: email,
          password: password,
        },
        headers: {
          "Content-Type": "application/json",
        },
      });
      let responseData = response.data.data;

      return responseData;
    } catch (err) {
      throw err;
    }
  };

  static pendingOrderDetails = async (rowsPerPage, page) => {
    try {
      let response = await axios({
        method: "post",
        baseURL: API_ORIGIN + "/orders/admin/pending/search",
        data: {
          filter: [],
          limit: rowsPerPage,
          skip: page * rowsPerPage,
          sort: "DESC",
        },
        headers: { Authorization: `Bearer ${authToken}` },
      });

      let orderDetail = response.data.data;

      return orderDetail;
    } catch (err) {
      throw err;
    }
  };

  static orderDetails = async (arrayData, rowsPerPage, page) => {
    try {
      let filterArray = [];
     
      if (arrayData && arrayData.length > 0) {
        arrayData.map((data) => {
          if(data.searchTerm !== "" && data.searchTerm !== undefined){
            filterArray.push({"id": data.searchTerm})
          }

          if(data.nameSearchTerm !== "" && data.nameSearchTerm !== undefined){
            filterArray.push({"keyword": data.nameSearchTerm})
          }

          if(data.phoneSearchTerm !== "" && data.phoneSearchTerm !== undefined){
            filterArray.push({"phone": data.phoneSearchTerm})
          }
    
          if(data.statusname !== "" && data.statusname !== undefined){
            filterArray.push({"status": data.statusname})
          }
    
          if(data.paymentMethod !== "" && data.paymentMethod !== undefined){
            filterArray.push({"payment_method": data.paymentMethod})
          }
    
          if(data.paymentStatus !== "" && data.paymentStatus !== undefined){
            filterArray.push({"payment_status": data.paymentStatus})
          }

          if(data.type !== "" && data.type !== undefined){
            filterArray.push({"currier_type": data.type})
          }
            
        })
      }

      let response = await axios({
        method: "post",
        baseURL: API_ORIGIN + "/orders/admin/search",
        data: {
          filter: filterArray,
          limit: rowsPerPage,
          skip: page * rowsPerPage,
          sort: "DESC",
        },
        headers: { Authorization: `Bearer ${authToken}` },
      });

      let orderDetail = response.data.data;

      return orderDetail;
    } catch (err) {
      throw err;
    }
  };

  static randomOrderDetails = async (arrayData, rowsPerPage, page) => {
    try {
      let filterArray = [];
     
      if (arrayData && arrayData.length > 0) {
        arrayData.map((data) => {
          if(data.searchTerm !== "" && data.searchTerm !== undefined){
            filterArray.push({"random_id": data.searchTerm})
          }

          if(data.nameSearchTerm !== "" && data.nameSearchTerm !== undefined){
            filterArray.push({"keyword": data.nameSearchTerm})
          }

          if(data.phoneSearchTerm !== "" && data.phoneSearchTerm !== undefined){
            filterArray.push({"phone": data.phoneSearchTerm})
          }
    
          if(data.statusname !== "" && data.statusname !== undefined){
            filterArray.push({"status": data.statusname})
          }
    
          if(data.paymentMethod !== "" && data.paymentMethod !== undefined){
            filterArray.push({"payment_method": data.paymentMethod})
          }
    
          if(data.paymentStatus !== "" && data.paymentStatus !== undefined){
            filterArray.push({"payment_status": data.paymentStatus})
          }

          if(data.type !== "" && data.type !== undefined){
            filterArray.push({"currier_type": data.type})
          }
            
        })
      }

      let response = await axios({
        method: "post",
        baseURL: API_ORIGIN + "/orders/admin/search",
        data: {
          filter: filterArray,
          limit: rowsPerPage,
          skip: page * rowsPerPage,
          sort: "DESC",
        },
        headers: { Authorization: `Bearer ${authToken}` },
      });

      let orderDetail = response.data.data;

      return orderDetail;
    } catch (err) {
      throw err;
    }
  };

  static orderDetailsBill = async (arrayData, rowsPerPage, page) => {
    try {
      let filterArray = [];
     
      if (arrayData && arrayData.length > 0) {
        arrayData.map((data) => {   
          if(data.searchTerm !== "" && data.searchTerm !== undefined){
            filterArray.push({"id": data.searchTerm})
          }

          if(data.statusname !== "" && data.statusname !== undefined){
            filterArray.push({"status": data.statusname})
          }
    
          if(data.paymentMethod !== "" && data.paymentMethod !== undefined){
            filterArray.push({"payment_method": data.paymentMethod})
          }
    
          if(data.paymentStatus !== "" && data.paymentStatus !== undefined){
            filterArray.push({"payment_status": data.paymentStatus})
          }

          if(data.courierType !== "" && data.courierType !== undefined){
            filterArray.push({"currier_type": data.courierType})
          }
            
        })
      }

      let response = await axios({
        method: "post",
        baseURL: API_ORIGIN + "/orders/admin/bill/search",
        data: {
          filter: filterArray,
          limit: rowsPerPage,
          skip: page * rowsPerPage,
          sort: "DESC",
        },
        headers: { Authorization: `Bearer ${authToken}` },
      });

      let orderDetail = response.data.data;

      return orderDetail;
    } catch (err) {
      throw err;
    }
  };

  static orderDetailsID = async (orderID) => {
    try {
      let response = await axios({
        method: "get",
        baseURL: API_ORIGIN + "/orders/admin/" + orderID,
        headers: { Authorization: `Bearer ${authToken}` },
      });

      let orderDetailID = response.data.data;

      return orderDetailID;
    } catch (err) {
      throw err;
    }
  };

  static orderDelete = async (orderID) => {
    try {
      let response = await axios({
        method: "delete",
        baseURL: API_ORIGIN + "/orders/" + orderID,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });
      let responseData = response.data.data;

      return responseData;
    } catch (err) {
      throw err;
    }
  };

  static orderUpdate = async (orderID, changedValues) => {
    try {
      console.log('orderID, changedValues',orderID, changedValues)
      let response = await axios({
        method: "put",
        baseURL: API_ORIGIN + "/orders/update/" + orderID,
        data: changedValues,

        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`
        },
      });
      let responseData = response.data.data;

      return responseData;
    } catch (err) {
      throw err;
    }
  };

  static orderAddressUpdate = async (orderID, name, phone1, phone2, address, district, city) => {
    try {
      let response = await axios({
        method: "put",
        baseURL: API_ORIGIN + "/orders/update/userData/" + orderID,
        data: {
          name: name,
          phone1: phone1,
          phone2: phone2,
          delivery_address: address,
          districtId: Number(district),
          city
        },

        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`
        },
      });
      let responseData = response.data.data;

      return responseData;
    } catch (err) {
      throw err;
    }
  };

  static resentorderDetails = async () => {
    try {
      let response = await axios({
        method: "post",
        baseURL: API_ORIGIN + "/orders/admin/search",
        data: {
          filter: [],
          limit: 20,
          skip: 0,
          sort: "DESC",
        },
        headers: { Authorization: `Bearer ${authToken}` },
      });

      let resentorderDetail = response.data.data;
      return resentorderDetail;
    } catch (err) {
      throw err;
    }
  };

  static userOrderDetails = async (
    statusname,
    customerID,
    rowsPerPage,
    page
  ) => {
    try {
      let filter = [];
      if (statusname && statusname.length > 0) {
        filter.push({ status: statusname });
      }

      if (customerID && customerID.length > 0) {
        filter.push({ userId: customerID });
      }

      let response = await axios({
        method: "post",
        baseURL: API_ORIGIN + "/orders/admin/search",
        data: {
          filter: filter,
          limit: rowsPerPage,
          skip: page * rowsPerPage,
          sort: "DESC",
        },
        headers: { Authorization: `Bearer ${authToken}` },
      });

      let orderDetail = response.data.data;

      return orderDetail;
    } catch (err) {
      throw err;
    }
  };

  static sendReviewSms = async (orderID) => {
    try {
      let response = await axios({
        method: "get",
        baseURL: API_ORIGIN + "/orders/admin/send/review/" + orderID,
        headers: {
          "Content-Type": "application/json",
        },
      });
      let responseData = response.data.data;

      return responseData;
    } catch (err) {
      throw err;
    }
  };

  static sendBulkReviewSms = async (orderIdList) => {
    try {
      let response = await axios({
        method: "post",
        baseURL: API_ORIGIN + "/orders/admin/send/bulk/reviews",
        data: {
          orderIdList
        },
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`
        },
      });
      let responseData = response.data.data;

      return responseData;
    } catch (err) {
      throw err;
    }
  };
}
